import { Button, Grid } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SystemObjectStore } from "../../ObjectStore/SystemObjectStore";
import { UserObjectStore } from "../../ObjectStore/UserObjectStore";

export type StoreDetailMenuType = "onlinelesson" | "studio" | "studioTag" | "businessHours" | "studioPrice" | "pack" | "equipment" | "adjustment" | "cancel"

const StoreDetailMenu: React.FC = () => {
    const { userObjectState } = React.useContext(UserObjectStore)
    const { systemObject } = React.useContext(SystemObjectStore)
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <Grid container alignItems="stretch" spacing={1}>
            {userObjectState.stfAccessList.includes("StudioSetting") &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "studio" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("studio", {state: 'studio'})
                        }}
                    >スタジオ設定</Button>
                </Grid>
            }
            {userObjectState.stfAccessList.includes("StudioTag") &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "studiotag" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("studiotag", {state: 'studiotag'})
                        }}
                    >スタジオタグ設定</Button>
                </Grid>
            }
            {userObjectState.stfAccessList.includes("WorkingTimeSetting") &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "businesshours" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("businesshours", {state: 'businesshours'})
                        }}
                    >営業時間設定</Button>
                </Grid>
            }
            {userObjectState.stfAccessList.includes("StudioChargeSetting") &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "studioprice" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("studioprice", {state: 'studioprice'})
                        }}
                    >スタジオ料金設定</Button>
                </Grid>
            }
            {userObjectState.stfAccessList.includes("StudioPackSetting") &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "pack" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("pack", {state: 'pack'})
                        }}
                    >パック料金設定</Button>
                </Grid>
            }
            {userObjectState.stfAccessList.includes("EquipmentSetting") &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "equipment" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("equipment", {state: 'equipment'})
                        }}
                    >レンタル機材設定</Button>
                </Grid>
            }
            {userObjectState.stfAccessList.includes("AdjustmentManager") &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "adjustment" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("adjustment", {state: 'adjustment'})
                        }}
                    >売上一覧</Button>
                </Grid>
            }
            {userObjectState.stfAccessList.includes("CancelCharge") &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "cancel" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("cancel", {state: 'cancel'})
                        }}
                    >キャンセル料管理</Button>
                </Grid>
            }
            {(systemObject.databaseVersion && systemObject.databaseVersion >= 11 && systemObject.enableOnlineLesson) &&
                <Grid item xs={6} md={3} sx={{
                    display: "flex",
                    alignItems: "stretch",
                    justifyContent: "stretch",
                }}>
                    <Button
                        fullWidth
                        size="small"
                        variant="contained"
                        color={location.state === "onlinelesson" ? "secondary" : "primary"}
                        onClick={()=>{
                            navigate("onlinelesson")
                        }}
                    >オンラインレッスン設定</Button>
                </Grid>
            }
        </Grid>
    );
}

export default StoreDetailMenu